import DataService from "./data.service";

export default {


  getUpdatedMetricId: function (metricMetadata, id) {
    let migrationMap = DataService.fetchMetricsIdMigration(metricMetadata);
    if (migrationMap[id]) {
      return migrationMap[id];
    } else {
      return id;
    }
  },
  
};
